import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import TableComponent from "../../Common/TableComponent/tableComponent";
import {
  createDeploymentInchargeMaster,
  getAllDeploymentInchargeMaster,
  getDeploymentInchargePassword,
  getInchargeById,
  updateDeploymentInchargeMaster,
  updateDeploymentInchargePassword,
} from "../../Apis/primaryDeploymentInchargeApi";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { TableLoader } from "../../Common/ShimmerLoader";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleNotch,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import {
  GetCircle,
  GetCirclebyID,
  GetWard,
  GetWardsbyCircleId,
  GetZone,
} from "../../Apis/organizationApi";
import * as XLSX from "xlsx"; // Import XLSX library for Excel operations
import ExcelJS from "exceljs";
import { canWritePermission } from "../../Common/helper/helpar";
const PrimaryDeploymentChargeMaster = ({ t }) => {
  const navigate = useNavigate();
  const [lgShow, setLgShow] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [loading, setLoading] = useState(true);
  const headers = [
    "InchargeName",
    "emailId",
    "mobileNumber",
    // "deployment_location_id",
    "zone",
    "circle",
    "ward",
    "status",
    "actions",
  ];
  // const headers = [
  //   "incharge_name",
  //   "mobile",
  //   "deployment_location_id",
  //   "status",
  //   "actions",
  // ];
  const [allZones, setAllZones] = useState([]);
  const [allCircles, setAllCircles] = useState([]);
  const [allWards, setAllWards] = useState([]);
  const [noWardsUnderCircle, setNoWardsUnderCircle] = useState(false);
  const [circleFetchError, setCircleFetchError] = useState(null);
  const [selectedWard, setSelectedWard] = useState("");
  const [selectedZone, setSelectedZone] = useState("");
  const [selectedCircles, setSelectedCircles] = useState([]);
  const [noCircles, setNoCircles] = useState(false);
  const [inchargeData, setInchargeData] = useState([]);
  const [editInchargeData, setEditInchargeData] = useState("");
  const [editInchargeId, setEditInchargeId] = useState(null);
  const [selectedIncharge, setSelectedIncharge] = useState(null);
  const [loadingCircles, setLoadingCircles] = useState(false);
  const [loadingWards, setLoadingWards] = useState(false);
  const [editUserData, setEditUserData] = useState("");
  const [isOptionsLoading, setIsOptionsLoading] = useState(true);
  const [circles, setCircles] = useState([]);
  const [wards, setWards] = useState([]);
  const [sortedData, setSortedData] = useState([]); // New state to store sorted data
  const [originalData, setOriginalData] = useState([]);
  const [sortConfig, setSortConfig] = useState(null);
  const [filterOriginalSFAInchargeData, setFilterOriginalSFAInchargeData] =
    useState([]);
  const [formInput, setFormInput] = useState({
    primaryDeploymentInchargeName: "",
    mobileNumber: "",
    emailId: "",
    password: "",
    // isActive: "",
    // deployment_location_id: "",
    zoneId: "",
    wardId: "",
    circleId: "",
    isActive: true,
    primaryDeploymentInchargeId: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [passwordshow, setPasswordShow] = useState(false);
  const [currentPasswordLoading, setCurrentPasswordLoading] = useState(false);
  const [showCurrentPasswordInput, setShowCurrentPasswordInput] =
    useState(false);
  const [CurrentPassword, setCurrentPassword] = useState("••••••••••••");
  const [canWriteValue, setCanWriteValue] = useState(null);

  useEffect(() => {
    setCanWriteValue(canWritePermission("SFA InCharges"));
  },[] )

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };
  const handlePasswordToggle = () => {
    setPasswordShow(!passwordshow);
  };

  const passwordValidationRegex = /^(?=.*[A-Z])(?=.*[\W])(?=.*\d).{8,}$/;

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setFormInput({ ...formInput, password: newPassword });

    // Validate password
    if (!passwordValidationRegex.test(newPassword)) {
      setPasswordError(
        "Password must contain at least one uppercase letter, one special character, and one number, with a minimum of 8 characters."
      );
    } else {
      setPasswordError(""); // Clear error if valid
    }
  };

  useEffect(() => {
    // Clear the password field when the component mounts
    setFormInput((prevData) => ({
      ...prevData,
      password: "", // Clear the password field
    }));
  }, []);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const resetFields = (reset) => {
    setFormInput({
      primaryDeploymentInchargeName: "",
      mobileNumber: "",
      emailId: "",
      password: "",
      zoneId: "",
      wardId: "",
      circleId: "",
      isActive: "",
      // deployment_location_id: "",
      primaryDeploymentInchargeId: "",
    });
    resetRef.current();
  };

  const resetRef = useRef(null);

  useEffect(() => {
    resetRef.current = reset;
  }, [reset]);

  const handleClose = () => {
    setFormSubmitted(false);
    resetFields();
    setLgShow(false);
    setCurrentPassword("••••••••••••");
    setShowCurrentPasswordInput(false);
    setIsEditMode(false);
    setSelectedIncharge(null);
    setPasswordError("");
  };
  useEffect(() => {
    fetchIncharge();
  }, []);

  const currentPasswordClickHandler = async (data) => {
    setCurrentPasswordLoading(true);
    try {
      const res = await getDeploymentInchargePassword(
        data.primaryDeploymentInchargeId
      );
      setCurrentPassword(res?.data);
    } catch (error) {
      console.error("Error fetching password data:", error);
    } finally {
      setCurrentPasswordLoading(false);
    }
  };

  const fetchIncharge = async () => {
    try {
      // Fetch transfer station data

      const deploymentInchargeResponse = await getAllDeploymentInchargeMaster();
      if (!deploymentInchargeResponse) {
        // Handle the case where response is undefined
        console.error(
          "Transfer station response is undefined:",
          deploymentInchargeResponse
        );
        return []; // Return an empty array or handle it according to your application logic
      }

      // Assuming transferStationResponse contains the array of transfer station objects
      const deploymentInchargedata = deploymentInchargeResponse; // Assuming this is how you get the transfer station data

      // Fetch additional data (zones, circles, wards)
      const zoneResponse = await GetZone();
      const circleResponse = await GetCircle();
      const wardResponse = await GetWard();

      // Create dictionaries for easy mapping
      const zoneNamesDictionary = {};
      zoneResponse.forEach((zone) => {
        zoneNamesDictionary[zone.zoneId] = zone.zoneName;
      });

      const circleNamesDictionary = {};
      circleResponse.forEach((circle) => {
        circleNamesDictionary[circle.circleId] = circle.circleName;
      });

      const wardNamesDictionary = {};
      wardResponse.forEach((ward) => {
        wardNamesDictionary[ward.wardId] = ward.wardName;
      });
      // Map transfer station data with zoneName, circleName, and wardName
      const mappedDeploymentInchargeData = deploymentInchargedata.map(
        (station) => ({
          ...station,
          zone: zoneNamesDictionary[station.zoneId] || "N/A",
          circle: circleNamesDictionary[station.circleId] || "N/A",
          ward: wardNamesDictionary[station.wardId] || "N/A",
          InchargeName: station.primaryDeploymentInchargeName,
          status: station.isActive ? "Active" : "InActive",
        })
      );

      // Sort the data based on the isActive field
      const sortedInchargeData = mappedDeploymentInchargeData.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });
      setInchargeData(sortedInchargeData);
      setFilterOriginalSFAInchargeData(sortedInchargeData);
      setOriginalData(deploymentInchargeResponse);
      // setInchargeData(mappedDeploymentInchargeData);
      setIsOptionsLoading(false);

      const zoneTrueValues = zoneResponse.filter(
        (item) => item.isActive === true
      );
      setAllZones(zoneTrueValues);
      const circleTrueValues = circleResponse.filter(
        (item) => item.isActive === true
      );
      setAllCircles(circleTrueValues);
      const wardTrueValues = wardResponse.filter(
        (item) => item.isActive === true
      );
      setAllWards(wardTrueValues);

      return mappedDeploymentInchargeData;
    } catch (error) {
      console.error("Error fetching transfer station data:", error);
      throw error; // Propagate the error for handling in the calling function
    }
  };
  const handleEditIncharge = async (selectedInchargeData) => {
    setEditInchargeData(selectedInchargeData);
    setEditInchargeId(selectedInchargeData.primaryDeploymentInchargeId);
    setSelectedIncharge(selectedInchargeData);
    setLgShow(true);
    setShowCurrentPasswordInput(true);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    // const locationIds = selectedInchargeData.deployment_location_id.map(
    //   (location) => location.id
    // );
    const { circleId, zoneId, wardId } = selectedInchargeData;
    setFormInput({
      ...formInput,
      zoneId,
      circleId,
      wardId,
      primaryDeploymentInchargeName:
        selectedInchargeData.primaryDeploymentInchargeName,
      mobileNumber: selectedInchargeData.mobileNumber,
      emailId: selectedInchargeData.emailId,
      password: selectedInchargeData.password,
      isActive: selectedInchargeData.isActive,
      // deployment_location_id: locationIds,
      primaryDeploymentInchargeId:
        selectedInchargeData.primaryDeploymentInchargeId,
    });
    // const selectedOptionsData =
    //   selectedInchargeData?.deployment_location_id?.map((locationName) => ({
    //     value: locationName.location_name,
    //     label: locationName.location_name,
    //   }));

    // const selectedOptionsData = selectedInchargeData.deployment_location_id.map(
    //   (locationId) => {
    //     const selectedLocation = options.find((option) => option.value === locationId);
    //     return selectedLocation
    //       ? { value: selectedLocation.locationName, label: selectedLocation.locationName }
    //       : null;
    //   }
    // ).filter(Boolean);

    // for multi select
    // setSelectedOptions(selectedOptionsData);
    try {
      const circlesData = await GetCirclebyID(zoneId);
      setAllCircles(circlesData);
      const wardsData = await GetWardsbyCircleId(circleId);
      setWards(wardsData);
    } catch (error) {
      console.error("Error fetching circles and wards data:", error);
    }
    reset();
    // setLoading(false)
  };

  const addNewIncharge = async (data) => {
    setFormSubmitted(true);

    // const firstDigit = formInput.mobileNumber.charAt(0);
    // if (!["6", "7", "8", "9"].includes(firstDigit)) {
    //   toast.error("Mobile number should start with 6, 7, 8, or 9", {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //   });
    //   return; // Prevent form submission
    // }
    try {
      setLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 1000));

      if (
        !formInput.primaryDeploymentInchargeName ||
        !formInput.mobileNumber ||
        !formInput.zoneId ||
        !formInput.circleId ||
        !formInput.wardId ||
        !formInput.emailId ||
        (!selectedIncharge && !formInput.password)
      ) {
        // toast.error("Please fill in all required fields.", {
        //   position: "top-right",
        //   autoClose: 5000,
        //   hideProgressBar: false,
        // });
        // Stop further execution
        return;
      }

      if (
        formInput.password && // If password is entered
        (!selectedIncharge || (selectedIncharge && formInput.password)) && // New password entered in update mode
        !passwordValidationRegex.test(formInput.password)
      ) {
        // toast.error(
        //   "Password must contain at least one uppercase letter, one special character, and one number, with a minimum of 8 characters.",
        //   {
        //     position: "top-right",
        //     autoClose: 5000,
        //     hideProgressBar: false,
        //   }
        // );
        return; // Prevent API call
      }
      const {
        zoneId,
        circleId,
        wardId,
        primaryDeploymentInchargeName,
        mobileNumber,
        emailId,
        password,
        isActive,
        // deployment_location_id,
        primaryDeploymentInchargeId,
      } = formInput;
      const requestData = {
        zoneId,
        circleId,
        wardId,
        primaryDeploymentInchargeName,
        mobileNumber,
        emailId,
        password,
        isActive,
        // deployment_location_id,
        primaryDeploymentInchargeId,
      };
      if (selectedIncharge) {
        const res = await updateDeploymentInchargeMaster(
          selectedIncharge.primaryDeploymentInchargeId,
          requestData
        );
        const paramData = {
          primaryInchargeId: selectedIncharge.primaryDeploymentInchargeId,
          password: requestData.password,
        };
        const password =
          requestData.password != undefined &&
          (await updateDeploymentInchargePassword(paramData));
        const successMessage = "SFA Incharge Updated Successfully!";
        toast.success(successMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        fetchIncharge();
        //reset();
        handleClose();
      } else {
        const res = await createDeploymentInchargeMaster(requestData);
        console.log(res, "responseeee");
        const successMessage = "SFA Incharge Added Successfully!";
        toast.success(successMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        reset();
        fetchIncharge();
        handleClose();
      }
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 409) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      }
    } finally {
      setLoading(false);
      setEditInchargeData("")
    }
  };

  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" && event.shiftKey === false) {
      event.preventDefault();
      callback(addNewIncharge);
    }
  };

  const handleZoneChange = async (zoneId) => {
    setFormInput((prevData) => ({
      ...prevData,
      zoneId: zoneId,
      circleId: "", // Reset circle ID when zone changes
    }));
    setSelectedCircles(""); // Clear selected circle
    if (zoneId) {
      try {
        const circlesData = await GetCirclebyID(zoneId); // Assuming there's a function to fetch circles by zone ID
        setAllCircles(circlesData);
      } catch (error) {
        console.error("Error fetching circles data:", error);
      } // Fetch circles data for the selected zone
    } else {
      // If no zone is selected, clear circles dropdown
      setAllCircles([]);
    }
  };

  const handleCircleChange = async (circleId) => {
    setFormInput((prevData) => ({
      ...prevData,
      circleId: circleId,
      wardId: "", // Reset wardId when circle changes
    }));
    setSelectedWard("");
    if (circleId) {
      try {
        const wardsData = await GetWardsbyCircleId(circleId);
        // Assuming there's a function to fetch wards by circle ID
        setWards(wardsData);
      } catch (error) {
        console.error("Error fetching wards data:", error);
      }
    } else {
      // If no circle is selected, clear wards dropdown
      setWards([]);
    }
  };

  const fetchCirclesAndWards = async (zoneId) => {
    try {
      const circlesData = await GetCirclebyID(zoneId);
      setAllCircles(circlesData);
      setSelectedCircles([]);
      setCircleFetchError(null);
      setNoCircles(false);
      setWards([]);
      // Do not fetch wards here
    } catch (error) {
      console.error("Error fetching circles data:", error);
      setCircleFetchError("Error fetching circles data");
      setAllCircles([]);
      setWards([]);
      setNoCircles(false);
      setWards([]);
    }
  };

  const fetchAllDataDetails = async () => {
    try {
      const zonesData = await GetZone();
      setAllZones(zonesData);
      if (selectedZone) {
        const circlesData = await GetCirclebyID(selectedZone);
        setAllCircles(circlesData);
        setSelectedCircles([]);
        setWards([]);
        setIsOptionsLoading(false);
      } else {
        setAllCircles([]);
        setSelectedCircles([]);
        setWards([]);
      }
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };

  useEffect(() => {
    fetchAllDataDetails();
    fetchIncharge();

    if (editInchargeId) {
      fetchCirclesAndWards(editInchargeData.zoneId);
    }
  }, []);

  useEffect(() => {
    fetchIncharge();
    // fetchLocation();
  }, []);

  const handleShow = () => {
    setLgShow(true);
    setLoading(true);
    setFormInput({
      primaryDeploymentInchargeName: "",
      mobileNumber: "",
      emailId: "",
      password: "",
      // isActive: "",
      // deployment_location_id: "",
      zoneId: "",
      wardId: "",
      circleId: "",
      isActive: true,
      primaryDeploymentInchargeId: "",
    });
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const handleViewInchargeData = async (id) => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(true);
      const response = await getInchargeById(id);
      const inchargeDetails = response.data.data;
      // console.log(response.data.data, "responseID");
      navigate("/deployment-charge-details", { state: { inchargeDetails } });
    } catch (error) {
      //  console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setFormInput((prevData) => ({
      ...prevData,
      [name]: value === "true" ? true : false,
    }));
  };
  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const downloadAsExcel = async () => {
    const dataToUse = sortedData.length > 0 ? sortedData : originalData;
    const sortedDataForExport = [...dataToUse].sort((a, b) => {
      // Place 'Active' records before 'Inactive'
      return a.isActive === b.isActive ? 0 : a.isActive ? -1 : 1;
    });
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `SFA Incharge Report Generated on: ${formattedDate}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("SFA Incharge");

    // Define styles
    const boldFont = { bold: true };

    // Add header and formatting
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 8);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Add "SFA Incharge Details" title
    worksheet.addRow(["", "", "SFA Incharge", ""]);
    worksheet.mergeCells(2, 2, 2, 8);
    worksheet.getCell(2, 2).value = "SFA Incharge";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "SFA Incharge Name",
      "Email Id",
      "Mobile Number",
      "Zone",
      "Circle",
      "Ward",
      "Status",
    ]);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left", color: "#fff" };
      if (colNumber >= 1 && colNumber <= 8) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" },
          bgColor: { argb: "FFFFFFFF" },
        };
      }
    });

    // Add data rows with names instead of IDs
    sortedDataForExport.forEach((item, index) => {
      const zone = allZones.find((z) => z.zoneId === item.zoneId);
      const circle = allCircles.find((c) => c.circleId === item.circleId);
      const ward = allWards.find((c) => c.wardId === item.wardId);
      worksheet
        .addRow([
          index + 1, // S.No (index + 1)
          item.primaryDeploymentInchargeName || "N/A", // Incharge Name
          item.emailId || "N/A", // Email Id
          item.mobileNumber || "N/A", // Mobile Number
          zone ? zone.zoneName : "N/A", // Zone name
          circle ? circle.circleName : "N/A", // Circle name
          ward ? ward.wardName : "N/A", // Ward name (added here)
          item.isActive ? "Active" : "InActive", // Status (Active/Inactive)
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          cell.alignment = { horizontal: "left" }; // Align text to the left for better readability
        });
    });

    // Set column widths for better formatting
    worksheet.columns = [
      { width: 5 }, // S.No
      { width: 30 }, // Incharge Name
      { width: 30 }, // Email Id
      { width: 20 }, // Mobile Number
      { width: 20 }, // Zone
      { width: 20 }, // Circle
      { width: 20 }, // Ward
      { width: 15 }, // Status
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "SFAInchargeDetails.xlsx"; // Default file name
    a.click();
    URL.revokeObjectURL(url); // Revoke the object URL to free up memory
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let sanitizedValue = value; // Initialize sanitized value with the input value
    if (name === "mobileNumber") {
      // Remove any non-numeric characters
      sanitizedValue = value.replace(/\D/g, "");

      // Check if the first digit is 0-5 and clear the value if invalid
      if (/^[0-5]/.test(sanitizedValue)) {
        sanitizedValue = "";
      } else {
        // Limit to 10 digits
        sanitizedValue = sanitizedValue.slice(0, 10);
      }
    }

    // Update the state based on the field name
    setFormInput((prevData) => ({ ...prevData, [name]: sanitizedValue }));
  };

  const handleSort = (sortConfig) => {
    // Assuming you have a method to sort data based on sortConfig
    const sorted = [...inchargeData].sort((a, b) => {
      if (sortConfig.order === "asc") {
        return a[sortConfig.column] > b[sortConfig.column] ? 1 : -1;
      } else {
        return a[sortConfig.column] < b[sortConfig.column] ? 1 : -1;
      }
    });

    setSortedData(sorted); // Update the sorted data
  };
  const handleSortAndExport = async () => {
    if (sortConfig) {
      handleSort(sortConfig); // Apply sorting
      await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for state update
    }
    const dataToExport = sortConfig ? sortedData : originalData; // Use sorted or original data
    downloadAsExcel(dataToExport); // Export the data
  };
  const searchSFAInchargeHandler = (e) => {
    const term = e.target.value.toLowerCase();
    const data = filterOriginalSFAInchargeData.filter(
      (item) =>
        item?.InchargeName?.toLowerCase()?.includes(term) ||
        item?.mobileNumber?.toLowerCase()?.includes(term)
    );
    setInchargeData(data);
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 class="text-start mb-3">{t("SFA Incharges")}</h4>
            <div className="row mt-3 align-items-center">
              <div className="col-md-3">
                <input
                  placeholder="Search SFA Incharge"
                  type="text"
                  className="form-control bg-white"
                  onInput={searchSFAInchargeHandler}
                />
              </div>
              <div className="col-md-9">
                <div className="d-flex justify-content-end ">
                  {canWriteValue === true ? (
                    <button className="button-container" onClick={handleShow}>
                      <i className="fa-solid fa-plus me-1 icon-container"></i>
                      {t("Add SFA Incharge")}
                    </button>
                  ) : (
                    ""
                  )}
                  <button
                    className="btn btn-excel"
                    onClick={handleSortAndExport}
                  >
                    <i class="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                    Excel
                  </button>
                </div>
              </div>
            </div>

            <div className="card mt-3">
              <div className="card-body">
                <TableComponent isLoading={isOptionsLoading}
                  DataFetchURL={inchargeData}
                  headers={headers}
                  filterFunction={(data) =>
                    data.filter(
                      (item) => item.status === 1 || item.status === 2
                    )
                  }
                  editData={handleEditIncharge}
                  editInchargeData={editInchargeData}
                  viewData={(id) => handleViewInchargeData(id)}
                  onSort={handleSort}
                />
                {/* ) : (
                      <div>No data found</div>
                    )
                  )} */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => {
          setLgShow(false);
          setCurrentPassword("••••••••••••");
        }}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {/* Add Deployment Incharge Form */}
            {selectedIncharge ? "Edit SFA incharge" : "Add SFA incharge"}
          </Modal.Title>
          <i
            class="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form
            onSubmit={handleSubmit(addNewIncharge)}
            onKeyDown={(e) => {
              handleKeyDown(e, handleSubmit);
            }}
          >
            <div className="row">
              {/* {selectedIncharge ? ( */}
              <div className="col-md-4" style={{ display: "none" }}>
                <div className="form-group">
                  <label className="form-label">ID</label>
                  <input
                    type="number"
                    className="form-control"
                    name="primaryDeploymentInchargeId"
                    {...register("primaryDeploymentInchargeId")}
                    value={formInput.primaryDeploymentInchargeId}
                    readOnly
                    onChange={(e) =>
                      setFormInput({
                        ...formInput,
                        primaryDeploymentInchargeId: e.target.value,
                      })
                    }
                    disabled={!canWriteValue}
                  />
                </div>
              </div>
              {/* ) : (
                ""
              )} */}
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Primary Deployment incharge Name
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="primaryDeploymentInchargeName"
                    className={`form-control ${
                      formInput.primaryDeploymentInchargeName || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    {...register("primaryDeploymentInchargeName")}
                    value={formInput.primaryDeploymentInchargeName}
                    onChange={(e) => {
                      let sanitizedValue = e.target.value
                        .slice(0, 42) // Limit to 42 characters
                        .replace(/[^A-Za-z ]/g, "")
                        .replace(/^\s+/, "") // Remove leading spaces
                        .replace(/\s{2,}/g, " "); // Replace multiple spaces with a single space

                      setFormInput({
                        ...formInput,
                        primaryDeploymentInchargeName: sanitizedValue,
                      });
                    }}
                    placeholder="Enter Incharge Name"
                    maxLength={42}
                    disabled={!canWriteValue}
                  />

                  {!formInput.primaryDeploymentInchargeName &&
                    formSubmitted && (
                      <div className="required-message small">
                        Primary Deployment incharge Name is Required
                      </div>
                    )}
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Mobile Number<span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    // type="number"
                    name="mobileNumber"
                    // pattern="[0-9]{10}" // Specify the pattern for 10 digits
                    title="Mobile number must be exactly 10 digits long."
                    className={`form-control ${
                      formInput.mobileNumber || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    {...register("mobileNumber")}
                    value={formInput.mobileNumber}
                    min={0}
                    onInput={(e) => {
                      const maxLength = 10;
                      if (e.target.value.length > maxLength) {
                        e.target.value = e.target.value.slice(0, maxLength);
                      }
                    }}
                    onChange={handleInputChange}
                    placeholder="Enter Mobile Number"
                    // maxLength={42}
                    disabled={!canWriteValue}
                  />
                  {!formInput.mobileNumber && formSubmitted && (
                    <div className="required-message small">
                      Mobile Number is Required
                    </div>
                  )}

                  {formInput.mobileNumber &&
                    formInput.mobileNumber.length !== 10 &&
                    formSubmitted && (
                      <div className="required-message small">
                        Mobile number must be 10 digits
                      </div>
                    )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Email ID<span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="email"
                    name="emailId"
                    className={`form-control ${formInput.emailId || !formSubmitted ? "" : "input-error"
                      }`}
                    {...register("emailId")}
                    value={formInput.emailId}
                    onChange={(e) =>
                      setFormInput({ ...formInput, emailId: e.target.value.replace(/\s/g, "") })
                    }
                    onKeyDown={(e) => {
                      if (e.key === " ") {
                        e.preventDefault(); 
                      }
                    }}
                    onPaste={(e) => {
                      e.preventDefault();
                      const pastedText = e.clipboardData.getData("text").replace(/\s/g, ""); // Remove spaces
                      setFormInput((prev) => ({ ...prev, emailId: pastedText }));
                    }}
                    placeholder="Enter Email ID"
                    maxLength={42}
                    disabled={!canWriteValue}
                  />
                 

                  {!formInput.emailId && formSubmitted && (
                    <div className="required-message small">Email ID is Required</div>
                  )}
                </div>
              </div>

              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Zone <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    value={formInput.zoneId}
                    {...register("zoneId")}
                    name="zoneId"
                    className={`form-select ${
                      formInput.zoneId || !formSubmitted ? "" : "input-error"
                    }`}
                    onChange={(e) => {
                      const selectedZoneId = e.target.value;
                      setSelectedZone(selectedZoneId);

                      // Check if the selected zone is different from the previously selected zone
                      if (selectedZoneId !== selectedZone) {
                        // Fetch circles and wards only if the zone is different
                        fetchCirclesAndWards(selectedZoneId);
                      }
                      // Update formInput with the selected zoneId
                      setFormInput({
                        ...formInput,
                        zoneId: selectedZoneId,
                        circleId: "", // Reset circleId when zone changes
                        wardId: "", // Reset wardId when zone changes
                      });
                    }}
                    disabled={!canWriteValue}
                  >
                    <option value="">Select</option>
                    {allZones?.map((zone) => (
                      <option key={zone.zoneId} value={zone.zoneId}>
                        {zone.zoneName}
                      </option>
                    ))}
                  </select>
                  {!formInput.zoneId && formSubmitted && (
                    <div className="required-message small">Zone is Required</div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Circle <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    value={formInput.circleId}
                    name="circleId"
                    className={`form-select ${
                      formInput.circleId || !formSubmitted ? "" : "input-error"
                    }`}
                    {...register("circleId")}
                    onChange={(e) => {
                      setFormInput((prevData) => ({
                        ...prevData,
                        circleId: e.target.value,
                      }));
                      handleCircleChange(e.target.value);
                    }}
                    // disabled={!formInput.zoneId}
                    disabled={!canWriteValue}
                  >
                    {/* {allCircles.length === 0 && (
                      <option value="" disabled>
                        No circles found
                      </option>
                    )} */}
                    <option value="">Select</option>
                    {loadingCircles && (
                      <option disabled>Loading circles...</option>
                    )}
                    {Array.isArray(allCircles) && allCircles.length > 0 ? (
                      allCircles.map((circle) => (
                        <option key={circle.circleId} value={circle.circleId}>
                          {circle.circleName}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        No circles found
                      </option>
                    )}
                  </select>
                  {!formInput.circleId && formSubmitted && (
                    <div className="required-message small">Circle is Required</div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Ward <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    value={formInput.wardId}
                    name="wardId"
                    className={`form-select ${
                      formInput.wardId || !formSubmitted ? "" : "input-error"
                    }`}
                    {...register("wardId")}
                    onChange={(e) => {
                      setFormInput((prevData) => ({
                        ...prevData,
                        wardId: e.target.value,
                      }));
                    }}
                    // disabled={!formInput.circleId}
                    disabled={!canWriteValue}
                  >
                    {/* {allWards.length === 0 && (
                      <option value="" disabled>
                        No Wards found
                      </option>
                    )} */}
                    <option value="">Select</option>
                    {loadingWards && <option disabled>Loading Wards...</option>}
                    {/* {Array.isArray(allWards) &&
                      allWards.map((ward) => (
                        <option key={ward.wardId} value={ward.wardId}>
                          {ward.wardName}
                        </option>
                      ))} */}
                    {wards?.map((ward) => (
                      <option key={ward.wardId} value={ward.wardId}>
                        {ward.wardName}
                      </option>
                    ))}
                  </select>
                  {!formInput.wardId && formSubmitted && (
                    <div className="required-message small">Ward is Required</div>
                  )}
                </div>
              </div>

              {showCurrentPasswordInput && (
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="form-label">Current Password</label>
                    <div className="input-group">
                      <input
                        type={"text"}
                        name="password"
                        id="passwordInput"
                        // placeholder={editInchargeData ? "Enter New Password" : "Enter Password"}
                        maxLength={20}
                        className="form-control"
                        value={CurrentPassword}
                        autoComplete="new-password"
                        disabled
                      />
                      <div className="input-group-append">
                        <span
                          className="input-group-text"
                          onClick={() =>
                            currentPasswordClickHandler(editInchargeData)
                          }
                          // onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                          style={{ cursor: "pointer" }}
                        >
                          {currentPasswordLoading ? (
                            <FontAwesomeIcon spin icon={faCircleNotch} />
                          ) : (
                            <FontAwesomeIcon icon={faEye} />
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    {editInchargeData ? "Change Password" : "Password"}{" "}
                    <span style={{ color: "#EC1117" }}> {editInchargeData?"" : "*"}</span>
                  </label>
                  <div className="input-group">
                    <input
                      type={passwordshow ? "text" : "password"}
                      name="password"
                      id="passwordInput"
                      placeholder={
                        editInchargeData
                          ? "Enter New Password"
                          : "Enter Password"
                      }
                      maxLength={20}
                      className={`form-control ${
                        formInput.password || !formSubmitted
                          ? ""
                          : "input-error"
                      }`}
                      value={formInput.password}
                      autoComplete="new-password"
                      // onChange={(e) => setFormInput({ ...formInput, password: e.target.value })}
                      onChange={handlePasswordChange}
                      disabled={!canWriteValue}
                    />
                    <div className="input-group-append">
                      <span
                        className="input-group-text"
                        onClick={handlePasswordToggle}
                        style={{ cursor: "pointer" }}
                      >
                        <FontAwesomeIcon
                          icon={passwordshow ? faEye : faEyeSlash}
                        />
                      </span>
                    </div>
                  </div>
                  {passwordError && (
                    <div className="text-danger small">{passwordError}</div>
                  )}
                  {!formInput.password &&
                    formSubmitted &&
                    !selectedIncharge && (
                      <div className="required-message small">
                        Password is Required
                      </div>
                    )}
                </div>
              </div>

              {/* {selectedIncharge ? ( */}

              {/* ) : (
                ""
              )} */}
            </div>
            <div className="col-md-4 mt-2">
              <label className="form-label">
                Status <span style={{ color: "#EC1117" }}> *</span>
              </label>
              <div className="form-group" style={{ display: "flex" }}>
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="isActive"
                    id="activeRadio"
                    {...register("isActive")}
                    value="true"
                    checked={formInput.isActive === true}
                    // onChange={() =>
                    //   setFormInput({ ...formInput, isActive: "1" })
                    // }
                    onChange={handleStatusChange}
                  />
                  <label className="form-check-label" htmlFor="activeRadio">
                    Active
                  </label>
                </div>
                <div className="form-check" style={{ marginLeft: "60px" }}>
                  <input
                    type="radio"
                    className="form-check-input"
                    name="isActive"
                    id="inactiveRadio"
                    {...register("isActive")}
                    value="false"
                    checked={formInput.isActive === false}
                    // onChange={() =>
                    //   setFormInput({ ...formInput, isActive: "0" })
                    // }
                    onChange={handleStatusChange}
                  />
                  <label className="form-check-label" htmlFor="inactiveRadio">
                    InActive
                  </label>
                </div>
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-center">
              {/* {canWriteValue === true ? ( */}
                <button type="submit" className="deployment-button">
                  <i class="fa-solid fa-check done-container"></i>
                  {selectedIncharge ? t("Update") : t("Save")}
                </button>
              {/* ) : (
                ""
              )} */}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withTranslation()(PrimaryDeploymentChargeMaster);
